import React, {useEffect, useState, } from "react";
import { Space } from 'antd';
import { useDispatch } from 'react-redux';
import { getCrons } from "../stateManagement/actions/data";
import CronsList from "../components/sections/cronsList";

const CronsPage = () =>{

    const dispatch = useDispatch();
    const [data, setData] = useState(null);

    useEffect(() => {
        dispatch(getCrons(setData))
    }, [dispatch]);

    return(<>
        <h2>Crons execution for the last 30 days:</h2>
        <Space>
            <CronsList list={data?.imports}/>
        </Space>
    </>)
}

export default CronsPage;